"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FloatingActionButtonWrapper = exports.FloatingActionButton = void 0;
var FloatingActionButton_1 = require("./FloatingActionButton");
Object.defineProperty(exports, "FloatingActionButton", { enumerable: true, get: function () { return __importDefault(FloatingActionButton_1).default; } });
var FloatingActionButtonWrapper_1 = require("./FloatingActionButtonWrapper");
Object.defineProperty(exports, "FloatingActionButtonWrapper", { enumerable: true, get: function () { return __importDefault(FloatingActionButtonWrapper_1).default; } });
//# sourceMappingURL=index.js.map